import type { VoorgesteldClientPayload } from './portalProposalThread';

/** Session key: `{ move, voorgesteld, targetStage }` when recruiter opens Documentbuilder from Voorgesteld-flow. */
export const VOORGESTELD_RESUME_BUNDLE_KEY = 'wt_voorgesteld_resume_bundle';

export const RESUME_VOORGESTELD_MOVE_MODAL_EVENT = 'wt:resume-voorgesteld-move-modal';

export type ResumeVoorgesteldMoveModalDetail = {
  vacancyId?: string;
  applicationId?: string;
};

/** localStorage: concept van het voorstelvenster (per sollicitatie). */
export const VOORGESTELD_MOVE_DRAFT_KEY_PREFIX = 'wt_voorgesteld_move_draft_v1:';

export type VoorgesteldMoveDraftV1 = {
  voorgesteldClient?: VoorgesteldClientPayload;
  communicationChannel?: 'email' | 'whatsapp' | 'log';
  selectedTemplateId?: string;
  moveSubject?: string;
  moveMessage?: string;
  internalNote?: string;
  cc?: string;
  bcc?: string;
  selectedFromEmail?: string;
  targetStage?: string;
  savedAt?: string;
};

export function voorgesteldMoveDraftStorageKey(applicationId: string): string {
  return `${VOORGESTELD_MOVE_DRAFT_KEY_PREFIX}${String(applicationId || '').trim()}`;
}

export function saveVoorgesteldMoveDraft(applicationId: string, draft: VoorgesteldMoveDraftV1): void {
  const id = String(applicationId || '').trim();
  if (!id) return;
  try {
    localStorage.setItem(voorgesteldMoveDraftStorageKey(id), JSON.stringify({ ...draft, savedAt: new Date().toISOString() }));
  } catch {
    /* quota / private mode */
  }
}

export function loadVoorgesteldMoveDraft(applicationId: string): VoorgesteldMoveDraftV1 | null {
  const id = String(applicationId || '').trim();
  if (!id) return null;
  try {
    const raw = localStorage.getItem(voorgesteldMoveDraftStorageKey(id));
    if (!raw) return null;
    return JSON.parse(raw) as VoorgesteldMoveDraftV1;
  } catch {
    return null;
  }
}

export function clearVoorgesteldMoveDraft(applicationId: string): void {
  const id = String(applicationId || '').trim();
  if (!id) return;
  try {
    localStorage.removeItem(voorgesteldMoveDraftStorageKey(id));
  } catch {
    /* ignore */
  }
}

type ResumeMoveLike = {
  applicationId?: string;
  candidateId?: string;
  candidateRealId?: string;
  vacancyId?: string;
};

/** Bundle uit sessionStorage moet matchen met vacancy + sollicitatie uit het resume-event (IDs kunnen per scherm verschillen). */
export function resumeBundleMatchesVacancyEvent(
  bundle: { move?: ResumeMoveLike } | null | undefined,
  detail: { vacancyId?: string; applicationId?: string }
): boolean {
  const move = bundle?.move;
  if (!move || !detail?.vacancyId) return false;
  if (String(move.vacancyId || '').trim() !== String(detail.vacancyId).trim()) return false;
  const want = String(detail.applicationId || '').trim();
  if (!want) return true;
  const ids = [
    String(move.applicationId || '').trim(),
    String(move.candidateId || '').trim(),
    String(move.candidateRealId || '').trim(),
  ].filter(Boolean);
  if (!ids.length) return true;
  return ids.some((id) => id === want);
}